import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebaseの設定（環境変数から取得、なければデフォルト）
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDDK7FMjsB40NLq2d1sRtCUh-e8ojYoB6A",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "miniapplify.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "miniapplify",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "miniapplify.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "164759910378",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:164759910378:web:9b1ea691e043131a046493",
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-N3RD9EMSMY"
  };

console.log('Firebase Config:', {
  projectId: firebaseConfig.projectId,
  apiKey: firebaseConfig.apiKey ? '***' + firebaseConfig.apiKey.slice(-10) : 'NOT SET'
});

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firebase Authの初期化
export const auth = getAuth(app);

// Firestoreの初期化
export const firestore = getFirestore(app);

// Analytics初期化（サポート確認付き）
let analytics = null;
const initAnalytics = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      analytics = getAnalytics(app);
      console.log('✅ Firebase Analytics initialized successfully');
    } else {
      console.log('Firebase Analytics is not supported in this environment');
    }
  } catch (error) {
    console.error('Error initializing Firebase Analytics:', error);
  }
  return analytics;
};

// Analytics初期化を実行
initAnalytics();

export { analytics };
export const getAnalyticsInstance = () => analytics;
export default app;